// import React, { useRef, useEffect, useState } from "react";
// import "../styles/TeacherVideoTags.css";
// import { teacherTagPercentage } from "../Services/AllServices";
// import { getUserID } from "../Storage/Storage";

// const VideoTags = () => {
//   const [tagList, setTagList] = useState([]);
//   const tagsRef = useRef(null);
//   const [isLeftArrowVisible, setIsLeftArrowVisible] = useState(false);
//   const [isRightArrowVisible, setIsRightArrowVisible] = useState(true);

//   useEffect(() => {
//     const fetchTagPercentage = async () => {
//       try {
//         const userId = await getUserID();
//         const formData = { user_id: userId };

//         await teacherTagPercentage(formData, (response) => {
//           if (response && response.status === "success") {
//             const { totalTags, tag_percentages } = response.data;

//             // Create a tag list with name and percentage
//             const tagsWithProgress = Object.keys(totalTags).map((tag) => {
//               return {
//                 name: tag.trim(), // Trim whitespace from tag name
//                 progress: tag_percentages[tag] || 0, // Get percentage or 0 if not found
//               };
//             });

//             // Sort tags by progress in descending order
//             tagsWithProgress.sort((a, b) => b.progress - a.progress);
//             setTagList(tagsWithProgress);
//           }
//         });
//       } catch (error) {
//         console.error("Failed to fetch tags progress", error);
//       }
//     };

//     fetchTagPercentage();
//   }, []); // Empty array means it runs only on mount

//   const tags = tagList.map((tag) => tag.name); // Create tags array from tagList

//   const scrollRight = () => {
//     tagsRef.current.scrollBy({ left: 350, behavior: "smooth" });
//   };

//   const scrollLeft = () => {
//     tagsRef.current.scrollBy({ left: -350, behavior: "smooth" });
//   };

//   const manageScroll = () => {
//     const { scrollLeft, scrollWidth, clientWidth } = tagsRef.current;

//     setIsLeftArrowVisible(scrollLeft > 0);
//     setIsRightArrowVisible(scrollLeft <= scrollWidth - clientWidth);
//   };

//   useEffect(() => {
//     const tagsElement = tagsRef.current;
//     tagsElement.addEventListener("scroll", manageScroll);
//     manageScroll(); // Initial check on component mount

//     return () => tagsElement.removeEventListener("scroll", manageScroll);
//   }, []);

//   return (
//     <div className="video-tags-container">
//       {isLeftArrowVisible && (
//         <span className="video-tag-left-arrow-active" onClick={scrollLeft}>
//           <svg
//             xmlns="http://www.w3.org/2000/svg"
//             fill="none"
//             viewBox="0 0 24 24"
//             strokeWidth="1.5"
//             stroke="currentColor"
//             className="size-6"
//           >
//             <path
//               strokeLinecap="round"
//               strokeLinejoin="round"
//               d="M15.75 19.5 8.25 12l7.5-7.5"
//             />
//           </svg>
//         </span>
//       )}

//       <div className="video-tags" ref={tagsRef}>
//         {tags.map((tag, index) => (
//           <span key={index} className="video-tag">
//             {tag}
//           </span>
//         ))}
//       </div>

//       {isRightArrowVisible && (
//         <span className="video-tag-right-arrow-active" onClick={scrollRight}>
//           <svg
//             xmlns="http://www.w3.org/2000/svg"
//             fill="none"
//             viewBox="0 0 24 24"
//             strokeWidth="1.5"
//             stroke="currentColor"
//             className="size-6"
//           >
//             <path
//               strokeLinecap="round"
//               strokeLinejoin="round"
//               d="m8.25 4.5 7.5 7.5-7.5 7.5"
//             />
//           </svg>
//         </span>
//       )}
//     </div>
//   );
// };

// export default VideoTags;

import React, { useRef, useEffect, useState } from "react";
import "../styles/TeacherVideoTags.css";
import { teacherTagPercentage } from "../Services/AllServices";
import { getUserID } from "../Storage/Storage";

const VideoTags = () => {
  const [tagList, setTagList] = useState([]);
  const tagsRef = useRef(null);
  const [isLeftArrowVisible, setIsLeftArrowVisible] = useState(false);
  const [isRightArrowVisible, setIsRightArrowVisible] = useState(false); // Default hidden

  useEffect(() => {
    const fetchTagPercentage = async () => {
      try {
        const userId = await getUserID();
        const formData = { user_id: userId };

        await teacherTagPercentage(formData, (response) => {
          if (response && response.status === "success") {
            const { totalTags, tag_percentages } = response.data;

            // Create a tag list with name and percentage
            const tagsWithProgress = Object.keys(totalTags).map((tag) => {
              return {
                name: tag.trim(), // Trim whitespace from tag name
                progress: tag_percentages[tag] || 0, // Get percentage or 0 if not found
              };
            });

            // Sort tags by progress in descending order
            tagsWithProgress.sort((a, b) => b.progress - a.progress);
            setTagList(tagsWithProgress);
          }
        });
      } catch (error) {
        console.error("Failed to fetch tags progress", error);
      }
    };

    fetchTagPercentage();
  }, []); // Empty array means it runs only on mount

  const tags = tagList.map((tag) => tag.name); // Create tags array from tagList

  const scrollRight = () => {
    tagsRef.current.scrollBy({ left: 350, behavior: "smooth" });
  };

  const scrollLeft = () => {
    tagsRef.current.scrollBy({ left: -350, behavior: "smooth" });
  };

  const manageScroll = () => {
    const { scrollLeft, scrollWidth, clientWidth } = tagsRef.current;

    setIsLeftArrowVisible(scrollLeft > 0);
    setIsRightArrowVisible(
      scrollWidth > clientWidth && scrollLeft <= scrollWidth - clientWidth
    );
  };

  useEffect(() => {
    const tagsElement = tagsRef.current;

    const checkOverflow = () => {
      const { scrollWidth, clientWidth } = tagsElement;
      setIsRightArrowVisible(scrollWidth > clientWidth); // Show right arrow only if content overflows
    };

    // Use setTimeout to ensure DOM is fully rendered
    setTimeout(() => {
      checkOverflow();
    }, 0);

    tagsElement.addEventListener("scroll", manageScroll);

    return () => tagsElement.removeEventListener("scroll", manageScroll);
  }, [tagList]);

  return (
    <div className="video-tags-container">
      {isLeftArrowVisible && (
        <span className="video-tag-left-arrow-active" onClick={scrollLeft}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="size-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M15.75 19.5 8.25 12l7.5-7.5"
            />
          </svg>
        </span>
      )}

      <div className="video-tags" ref={tagsRef}>
        {tags.map((tag, index) => (
          <span key={index} className="video-tag">
            {tag}
          </span>
        ))}
      </div>

      {isRightArrowVisible && (
        <span className="video-tag-right-arrow-active" onClick={scrollRight}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="size-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="m8.25 4.5 7.5 7.5-7.5 7.5"
            />
          </svg>
        </span>
      )}
    </div>
  );
};

export default VideoTags;
